import { track as vercelTrack } from '@vercel/analytics';

export const trackEvent = (name, properties) => {
  try {
    if (properties && typeof properties === 'object') {
      vercelTrack(name, properties);
    } else {
      vercelTrack(name);
    }
  } catch (_) {
    // Swallow — analytics must never break the UI
  }
};
